import { ISymbolData } from '../../../../../parseToTree.types';

export const getRanges = (positions: ISymbolData[]): ISymbolData[] => {
  const ranges: ISymbolData[] = [];
  let startPosition: number | null = null;

  for (let i = 0; i < positions.length; i++) {
    const position = positions[i];

    if (position.closeTag) {
      ranges.push({ start: position.start, end: position.closeTag.end });
      continue;
    }

    if (startPosition === null) {
      startPosition = position.start;
      continue;
    }

    ranges.push({ start: startPosition, end: position.end });
    startPosition = null;
  }

  return ranges;
};
